import { Suspense } from "react"
import useOrganizationView from "../organization.service"
import ErrorBoundary from "../../../../utils/error-boundary"
import AllowanceList from "./allowance-list"
import { Typography } from "../../../../ppui"

const OrganizationAllowaanceForAdmin = () => {
  const { allownceList,
    loadingUi } = useOrganizationView();
  return <>
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
      <Suspense fallback={<p>loading.....</p>}>
      <Typography variant="h5" >
      Allowance Information

        </Typography>
        <AllowanceList
          allowanceListResponse={allownceList}
          isFetching={loadingUi} />
      </Suspense>
    </ErrorBoundary>
  </>
}

export default OrganizationAllowaanceForAdmin